const MESSAGE_SELECTOR = "[data-msg-id]";

const finiteNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export const captureChatPrependPosition = (feed) => {
  if (!feed) return null;

  const scrollTop = finiteNumber(feed.scrollTop);
  const scrollHeight = finiteNumber(feed.scrollHeight);
  const clientHeight = finiteNumber(feed.clientHeight);
  const viewBottom = scrollTop + clientHeight;
  const nodes = Array.from(feed.querySelectorAll?.(MESSAGE_SELECTOR) || []);

  const anchor = nodes.find((node) => {
    const id = String(node?.getAttribute?.("data-msg-id") || "").trim();
    if (!id) return false;

    const top = finiteNumber(node.offsetTop);
    const bottom = top + finiteNumber(node.offsetHeight);
    return bottom > scrollTop + 1 && top < viewBottom - 1;
  });

  return {
    anchorId: String(anchor?.getAttribute?.("data-msg-id") || "").trim() || null,
    anchorOffset: anchor ? finiteNumber(anchor.offsetTop) - scrollTop : 0,
    scrollHeight,
    scrollTop,
  };
};

export const restoreChatPrependPosition = (feed, position) => {
  if (!feed || !position) return false;

  const nodes = Array.from(feed.querySelectorAll?.(MESSAGE_SELECTOR) || []);
  const anchor = position.anchorId
    ? nodes.find(
        (node) =>
          String(node?.getAttribute?.("data-msg-id") || "").trim() ===
          position.anchorId
      )
    : null;

  const targetScrollTop = anchor
    ? finiteNumber(anchor.offsetTop) - finiteNumber(position.anchorOffset)
    : finiteNumber(position.scrollTop) +
      Math.max(0, finiteNumber(feed.scrollHeight) - finiteNumber(position.scrollHeight));
  const maxScrollTop = Math.max(
    0,
    finiteNumber(feed.scrollHeight) - finiteNumber(feed.clientHeight)
  );

  feed.scrollTop = Math.min(Math.max(0, targetScrollTop), maxScrollTop);
  return Boolean(anchor);
};

export const findOldestChatItemId = (items) => {
  return (Array.isArray(items) ? items : []).reduce((oldestId, item) => {
    const id = finiteNumber(item?.id);
    if (id <= 0) return oldestId;
    return oldestId == null || id < oldestId ? id : oldestId;
  }, null);
};

export const prependOlderChatPage = (currentItems, olderItems) => {
  const current = Array.isArray(currentItems) ? currentItems : [];
  const older = Array.isArray(olderItems) ? olderItems : [];
  if (!older.length) return current;

  const knownIds = new Set(
    current.map((item) => finiteNumber(item?.id)).filter((id) => id > 0)
  );
  const pageIds = new Set();
  const uniqueOlder = older.filter((item) => {
    const id = finiteNumber(item?.id);
    if (id <= 0) return true;
    if (knownIds.has(id) || pageIds.has(id)) return false;
    pageIds.add(id);
    return true;
  });

  return uniqueOlder.length ? [...uniqueOlder, ...current] : current;
};
